<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: WUFAN
 * @Date: 2019-12-16
 * @LastEditors: WUFAN
 * @LastEditTime: 2019-12-18
 -->
<template >
    <div class="div_container">
        <div class="div_menu_container">
            <el-menu class="el-menu-demo" background-color="#333" active-text-color="#fff" text-color="#fff" mode="horizontal">
                <el-menu-item index="1" active-text-color="#fff" text-color="#fff" style=" ">忘记密码 >></el-menu-item>
                <el-menu-item index="2" style="float:right;" @click="didTapToIndex">返回首页</el-menu-item>
                <el-button type="info" style="float:right;margin-top:10px;" @click="didTapToIndex" icon="el-icon-s-home" circle></el-button>
            </el-menu>
        </div>
        <div class="div_input_container">
            <div class="div_temp_container">
                <!-- 选择找回密码方式  -->
                <findWay v-if="compType==='way'" @fatherMethod="funcChangeStatus"></findWay>
                <!-- 输入账户获取验证码 -->
                <accountInput v-if="compType==='account'"
                :selectType="selectType"
                :userInfo="userInfo"
                :retrievePasswordType="retrievePasswordType"
                @fatherMethod="funcChangeStatus"></accountInput>
                <!-- 输入验证码和密码进行密码重置 -->
                <pswAffirm v-if="compType==='psw'" :userInfo="userInfo" :retrievePasswordType="retrievePasswordType" @fatherMethod="funcChangeStatus"></pswAffirm>
            </div>
        </div>
    </div>
</template>
<script>
import accountInput from './accountInput'
import pswAffirm from './pswAffirm'
import findWay from './findWay'
export default {
  components: {
    accountInput,
    pswAffirm,
    findWay
  },
  data() {
    return {
      screenWidth: 1000, // 屏幕宽度
      compType: 'way',
      userInfo: {},
      retrievePasswordType: '', // 找回密码方式
      selectType: {}
    }
  },
  beforeCreate() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  mounted() {

  },

  methods: {
    // 步骤控制
    funcChangeStatus: function(childrenInfo) {
      switch (childrenInfo.status) {
        case 1:
          this.retrievePasswordType = childrenInfo.type
          this.selectType = childrenInfo.selectType
          this.account = this.funcGetAccountInfo(childrenInfo.account, this.retrievePasswordType, this.selectType)
          break
        case 2:
          this.compType = 'psw'
          break
        default:
          this.$message.error('操作失败')
          this.$router.go(-1)
      }
    },

    // 账号输入子组件回调请求获取用户信息
    funcGetAccountInfo: function(account, retrievePasswordType, selectType) {
      this.$http.post('/self/retrieve-password/account-info', {
        'loginName': account
      }).then(response => {
        this.userInfo = response.data
        console.info(this.userInfo[retrievePasswordType])
        if (this.userInfo[retrievePasswordType] === undefined ||
        this.userInfo[retrievePasswordType] === null || this.userInfo[retrievePasswordType] === '') {
          this.$message.error(selectType.noDataMatchTip ? selectType.noDataMatchTip : '您未预留所选找回方式的信息')
          return
        }
        this.compType = 'account'
      }).catch(error => {
        this.$message.error(error.msg)
      })
    },

    // 返回首页
    didTapToIndex: function() {
      this.$router.push({ path: '/login' })
    }
  }
}

</script>
<style lang='scss' scoped>
    .div_container{

    }
    .div_menu_container{
        background-color: #333
    }
    .div_input_container{
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .div_temp_container{
        margin: 0 auto;
        margin-top: 200px;
        width: 400px;
    }

</style>
